export default __webpack_public_path__ + "static/media/accommodations5_668.e6ef4ea9.webp";